import { ButtonConfig } from '@zipari/shared-ds-util-button';
import { AllControlsConfiguration } from '@zipari/shared-ds-util-form';
import { ModalConfig } from '@zipari/shared-ds-util-modal';

export interface FeedBackResponse {
  data: any;
  status: number;
  description?: string;
}

export interface FeedbackConfig {
  modalConfig: ModalConfig;
  footer: FeedbackFooterConfig;
  feedbackBodyText: string;
  feedbackText?: string;
  ratingText: string;
  feedbackForm: {
    controls: AllControlsConfiguration[];
  };
  successConfig: FeedbackBodyConfig;
  errorConfig: FeedbackBodyConfig;
  showFeedback: boolean;
}

export interface FeedbackBodyConfig {
  title: string;
  description: string;
}

export interface RatingIcon {
  text: string;
  class: string;
}

export interface FeedbackFooterConfig {
  cancel: ButtonConfig;
  submit: ButtonConfig;
  close: ButtonConfig;
}

export interface FeedbackRequestBody {
  category: string;
  rating: number;
  comments: string;
  created_at: string;
}

export const feedbackFormFields = {
  category: 'category',
  comments: 'comments',
};

export const feedbackRouting = {
  feedbackNavKey: 'mp_feedback',
  feedbackURL: 'mp-feedback',
};
